export type WorkspaceErrorSurface = "crm" | "my"

export function workspaceErrorSurface(hostname: string, pathname: string): WorkspaceErrorSurface | null {
  if (hostname.startsWith("crm.") || /^\/crm(?:\/|$)/.test(pathname)) return "crm"
  if (hostname.startsWith("my.") || /^\/my(?:\/|$)/.test(pathname)) return "my"
  return null
}

export function workspaceRecoveryHref(surface: WorkspaceErrorSurface, hostname: string, pathname: string) {
  const prefix = !hostname.startsWith(`${surface}.`) && new RegExp(`^/${surface}(?:/|$)`).test(pathname) ? `/${surface}` : ""
  return `${prefix}/overview/summary`
}
